

















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import SpouseDetailsMeta from './model/SpouseDetailsMeta'
import { NextOfKinDetailsMeta } from './model/NextOfKinDetailsMeta'
import { UserAdviserDetailsMeta } from './model/UserAdviserDetailsMeta'
import { NationalityOptions } from '@master/model/options/NationalityAndCountryOptions'

const userStore = namespace('UserStore')

@Component({
  components: {
    AppForm
  }
})
export default class TheSpouse extends Vue {
  @userStore.State
  private userAdviserDetails!: UserAdviserDetailsMeta

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get isOpsStaff () {
    return this.currentUser.systemrole === 'ops-staff'
  }

  get spouseDetails () {
    return this.userAdviserDetails.spouseDetails
  }

  get nextOfKinDetails () {
    return this.userAdviserDetails.nextOfKinDetails
  }

  get spouseDetailsStructure (): FormStructure<SpouseDetailsMeta> {
    return [
      {
        label: 'Spouse Name',
        key: 'name',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Occupation',
        key: 'occupation',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Date of Birth',
        key: 'dateOfBirth',
        type: 'date',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Race',
        key: 'race',
        options: [
          { label: 'Chinese', value: 'chinese' },
          { label: 'Malay', value: 'malay' },
          { label: 'Indian', value: 'indian' },
          { label: 'Eurasian', value: 'eurasian' },
          { label: 'Others', value: 'others' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'Citizenship',
        key: 'nationality',
        options: [
          { label: '', value: '' },
          { label: 'Singaporean', value: 'singaporean' },
          { label: 'Singapore PR', value: 'pr' },
          { label: 'Singapore Pass Holder', value: 'passholders' },
          { label: 'Other Citizenship', value: 'others' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'Please specify Nationality',
        key: 'nationalitySpecified',
        options: this.nationalityOptions,
        disabled: !this.isOpsStaff ||
          this.userAdviserDetails.spouseDetails.nationality ===
            'singaporean' ||
          this.userAdviserDetails.spouseDetails.nationality ===
            'singaporeanpr'
      },
      {
        label: 'ID Doc. Type',
        key: 'idDocType',
        options: [
          { label: 'Identity Card - Pink', value: 'ic-pink' },
          { label: 'Identity Card - Blue', value: 'ic-blue' },
          { label: 'Others', value: 'others' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'ID No.',
        key: 'idNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Contact No.',
        key: 'contactNumber',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get nextOfKinDetailsStructure (): FormStructure<NextOfKinDetailsMeta> {
    return [
      {
        label: 'Name',
        key: 'name',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Relationship',
        key: 'relationship',
        options: [
          { label: 'Aunt', value: 'aunt' },
          { label: 'Brother', value: 'brother' },
          { label: 'Cousin', value: 'cousin' },
          { label: 'Daughter', value: 'daughter' },
          { label: 'Father', value: 'father' },
          { label: 'Grandchild', value: 'grandchild' },
          { label: 'Grandparent', value: 'grandparent' },
          { label: 'Legal guardian', value: 'legal Guardian' },
          { label: 'Husband', value: 'husband' },
          { label: 'Mother', value: 'mother' },
          { label: 'Nephew', value: 'nephew' },
          { label: 'Niece', value: 'niece' },
          { label: 'Others', value: 'others' },
          { label: 'Spouse', value: 'spouse' },
          { label: 'Son', value: 'son' },
          { label: 'Sister', value: 'sister' },
          { label: 'Uncle', value: 'uncle' },
          { label: 'Ward', value: 'ward' },
          { label: 'Wife', value: 'wife' }
        ],
        disabled: !this.isOpsStaff
      },
      {
        label: 'Contact No.',
        key: 'contactNumber',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get nationalityOptions () {
    return NationalityOptions
  }
}
